import { Collapse, Divider, Grid, Typography } from "@mui/material";
import Appointment from "../interface/appointment";

const RenderCollapse = ({
  appointment,
}: {
  appointment: Appointment;
}): React.JSX.Element => (
  <Collapse
    in={appointment.expand}
    timeout="auto"
    unmountOnExit
    sx={{
      width: "100%",
    }}
  >
    <Divider sx={{ my: 1 }} />
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6} md={3}>
        <Typography variant="caption" color="initial">
          Telefonnummer
        </Typography>
        <Typography
          variant="body1"
          color="initial"
          sx={{
            wordBreak: "break-all",
          }}
        >
          {appointment.participantPhoneNumber}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6} md={5}>
        <Typography variant="caption" color="initial">
          Email-Adresse
        </Typography>
        <Typography variant="body1" color="initial">
          {appointment.participantEmail}
        </Typography>
      </Grid>

      <Grid item xs={12} sm={6} md={4}>
        <Typography variant="caption" color="initial">
          Standort
        </Typography>
        <Typography variant="body1" color="initial">
          {appointment.participantLocation}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={12}>
        <Typography variant="caption" color="initial">
          Qualifikation
        </Typography>
        <Typography variant="body1" color="initial">
          {appointment.participantQualification}
        </Typography>
      </Grid>
    </Grid>
  </Collapse>
);

export default RenderCollapse;
